import Chip from "@mui/material/Chip";
import LockIcon from "@mui/icons-material/Lock";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

export const rateTypeLabel = (fixedRate) => (fixedRate ? "Fixed" : "Variable");

/**
 * Fixed vs variable rate indicator. A missing `fixedRate` flag means a legacy
 * agreement created before fixed-rate lending, which is variable.
 */
export const RateTypeChip = ({ fixedRate, size = "small", sx }) =>
  fixedRate ? (
    <Chip
      icon={<LockIcon />}
      label="Fixed rate"
      color="info"
      size={size}
      sx={sx}
    />
  ) : (
    <Chip
      icon={<TrendingUpIcon />}
      label="Variable rate"
      variant="outlined"
      size={size}
      sx={sx}
    />
  );
